import { render, staticRenderFns } from "./perMRI.vue?vue&type=template&id=449a48ea&scoped=true"
import script from "./perMRI.vue?vue&type=script&lang=js"
export * from "./perMRI.vue?vue&type=script&lang=js"
import style0 from "./perMRI.vue?vue&type=style&index=0&id=449a48ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a48ea",
  null
  
)

export default component.exports